import { Link, NavLink } from 'react-router-dom';
import myLogo from '../images/HeaderDraftLion.png'; 

const navItem = ({ isActive }: { isActive: boolean }) =>
  `text-sm transition ${isActive ? 'text-amber-400' : 'text-slate-300 hover:text-white'}`;

export default function Nav() {
  return (
    <nav className="border-b border-slate-800 sticky top-0 bg-slate-950/80 backdrop-blur z-10">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-4 flex items-center justify-between gap-4">
        <Link to="/" className="flex items-center gap-2 text-xl font-bold tracking-tight shrink-0">
          {/* Logo scales with the viewport — narrow on phones so the nav links
              still fit on one line, full size on tablet/desktop. */}
          <img
            src={myLogo}
            alt="DraftLion"
            className="h-auto w-36 sm:w-52 md:w-72"
          />
        </Link>
        <div className="flex gap-4 sm:gap-6 shrink-0">
          <NavLink to="/setup" className={navItem}>Setup</NavLink>
          <NavLink to="/usage" className={navItem}>Usage Guide</NavLink>
          <NavLink to="/manage" className={navItem}>Manage</NavLink>
        </div>
      </div>
    </nav>
  );
}
